/* eslint-disable @typescript-eslint/no-explicit-any */

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box, Image, Tooltip } from '@mantine/core';

// Icons
import OverRangeIcon from '@assets/icons/over-range.svg';

// I18n
import { useTranslation } from 'react-i18next';

// Styles
import styles from './CellOverrangeStatus.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const CellOverrangeStatus = (props: {
	row: any;
}) => {
	/* ******************************** HOOKS ******************************* */
	const { t } = useTranslation();

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={styles.cell}>
			{props.row &&
				props.row.quantityCheck == 'OVER_RANGE' && (
					<Tooltip label={t('global.overRange')}>
						<Image
							className={styles.imgOverRange}
							src={OverRangeIcon}
						/>
					</Tooltip>
				)}
			{props.row &&
				props.row.quantityCheck == 'UNDER_RANGE' && (
					<Tooltip label={t('global.underRange')}>
						<Image
							className={styles.imgUnderRange}
							src={OverRangeIcon}
						/>
					</Tooltip>
				)}
		</Box>
	);
};
